import { authHeader } from 'services';
import { Api } from './api/axios.service';

const getVets = (
  page: number,
  amount: number,
  filter: string,
  bond: string
) => {
  return Api.get(
    `vet?page=${page}&amount=${amount}&filter=${filter}&bond=${bond}`,
    {
      headers: authHeader(),
    }
  );
};

const getVetMaxPage = (amount: number, filter: string, bond: string) => {
  return Api.get(
    `vet/max-page?amount=${amount}&filter=${filter}&bond=${bond}`,
    {
      headers: authHeader(),
    }
  );
};

const getCurrentUser = () => {
  return Api.get('/user', {
    headers: authHeader(),
  });
};

export const UserService = {
  getVets,
  getVetMaxPage,
  getCurrentUser,
};
